export default class EmployeeKnowledge {
    constructor() {
        this.id = null;

        this.hasCertificateOfGoodConduct = false;
        this.certificateOfGoodConductDelivered = null;
        this.certificateOfGoodConductValidUntil = null;

        this.hasFireProtectionPlan = false;
        this.fireProtectionPlanDoneAt = null;
        this.fireProtectionPlanValidUntil = null;

        this.hasFirstAidCertificate = false;
        this.firstAidCertificatePresentedAt = null;
        this.firstAidCertificateValidUntil = null;

        this.hasHealthCertificate = false;
        this.healthCertificateDelivered = null;
        this.healthCertificateValidUntil = null;

        this.hasHygienePlan = false;
        this.hygienePlanDoneAt = null;
        this.hygienePlanValidUntil = null;

        this.hasInfectionProtectionAct = false;
        this.infectionProtectionActDelivered = null;
        this.infectionProtectionActValidUntil = null;

        this.hasInfectionProtectionAct2 = false;
        this.infectionProtectionAct2Delivered = null;
        this.infectionProtectionAct2ValidUntil = null;

        this.miscellaneous = null;
        this.referenceJob = '';
        this.foreignEducationStatus = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const knowledge = new EmployeeKnowledge();

        if (!data.id) {
            return knowledge;
        }

        knowledge.id = data.id;

        knowledge.hasCertificateOfGoodConduct = data.hasCertificateOfGoodConduct;
        knowledge.certificateOfGoodConductDelivered = data.certificateOfGoodConductDelivered;
        knowledge.certificateOfGoodConductValidUntil = data.certificateOfGoodConductValidUntil;

        knowledge.hasFireProtectionPlan = data.hasFireProtectionPlan;
        knowledge.fireProtectionPlanDoneAt = data.fireProtectionPlanDoneAt;
        knowledge.fireProtectionPlanValidUntil = data.fireProtectionPlanValidUntil;

        knowledge.hasFirstAidCertificate = data.hasFirstAidCertificate;
        knowledge.firstAidCertificatePresentedAt = data.firstAidCertificatePresentedAt;
        knowledge.firstAidCertificateValidUntil = data.firstAidCertificateValidUntil;

        knowledge.hasHealthCertificate = data.hasHealthCertificate;
        knowledge.healthCertificateDelivered = data.healthCertificateDelivered;
        knowledge.healthCertificateValidUntil = data.healthCertificateValidUntil;

        knowledge.hasHygienePlan = data.hasHygienePlan;
        knowledge.hygienePlanDoneAt = data.hygienePlanDoneAt;
        knowledge.hygienePlanValidUntil = data.hygienePlanValidUntil;

        knowledge.hasInfectionProtectionAct = data.hasInfectionProtectionAct;
        knowledge.infectionProtectionActDelivered = data.infectionProtectionActDelivered;
        knowledge.infectionProtectionActValidUntil = data.infectionProtectionActValidUntil;

        knowledge.hasInfectionProtectionAct2 = data.hasInfectionProtectionAct2;
        knowledge.infectionProtectionAct2Delivered = data.infectionProtectionAct2Delivered;
        knowledge.infectionProtectionAct2ValidUntil = data.infectionProtectionAct2ValidUntil;

        knowledge.miscellaneous = data.miscellaneous;
        knowledge.referenceJob = data.referenceJob !== null ? data.referenceJob : '';
        knowledge.foreignEducationStatus = data.foreignEducationStatus;

        return knowledge;
    }

    serialize() {
        return {
            employeeKnowledgeId: this.id,
            hasCertificateOfGoodConduct: this.hasCertificateOfGoodConduct,
            certificateOfGoodConductDelivered: this.certificateOfGoodConductDelivered,
            certificateOfGoodConductValidUntil: this.certificateOfGoodConductValidUntil,
            hasFireProtectionPlan: this.hasFireProtectionPlan,
            fireProtectionPlanDoneAt: this.fireProtectionPlanDoneAt,
            fireProtectionPlanValidUntil: this.fireProtectionPlanValidUntil,
            hasFirstAidCertificate: this.hasFirstAidCertificate,
            firstAidCertificatePresentedAt: this.firstAidCertificatePresentedAt,
            firstAidCertificateValidUntil: this.firstAidCertificateValidUntil,
            hasHealthCertificate: this.hasHealthCertificate,
            healthCertificateDelivered: this.healthCertificateDelivered,
            healthCertificateValidUntil: this.healthCertificateValidUntil,
            hasHygienePlan: this.hasHygienePlan,
            hygienePlanDoneAt: this.hygienePlanDoneAt,
            hygienePlanValidUntil: this.hygienePlanValidUntil,
            hasInfectionProtectionAct: this.hasInfectionProtectionAct,
            infectionProtectionActDelivered: this.infectionProtectionActDelivered,
            infectionProtectionActValidUntil: this.infectionProtectionActValidUntil,
            hasInfectionProtectionAct2: this.hasInfectionProtectionAct2,
            infectionProtectionAct2Delivered: this.infectionProtectionAct2Delivered,
            infectionProtectionAct2ValidUntil: this.infectionProtectionAct2ValidUntil,
            miscellaneous: this.miscellaneous,
            referenceJob: this.referenceJob === '' ? null : this.referenceJob,
            foreignEducationStatus: this.foreignEducationStatus ? this.foreignEducationStatus.value : null,
        };
    }
}
